/**
 * 巨量广告红线规则配置编辑器分发：targeting_type → 对应富编辑器组件。
 *
 * - legal_date / launch_time_series：与腾讯同构，复用共享编辑器。
 * - bid_limit / qudaohao：巨量专属 JSON 编辑器。
 * - regions：展业地域已迁移到「我的资源 - 展业城市」页（页面层过滤该行，不再分发编辑器）。
 * - 未知类型兜底 GenericConfigEditor（双 textarea + JSON 校验）。
 */
import type { ComponentType } from "react";
import type { EditorProps } from "../redlineConfig/types";
import { LegalDateEditor } from "../redlineConfig/LegalDateEditor";
import { LaunchTimeEditor } from "../redlineConfig/LaunchTimeEditor";
import { GenericConfigEditor } from "../redlineConfig/GenericConfigEditor";
import { QudaohaoEditor } from "./QudaohaoEditor";
import { OceanBidLimitEditor } from "./OceanBidLimitEditor";

export const OCEAN_REDLINE_EDITOR_MAP: Record<string, ComponentType<EditorProps>> = {
  legal_date: LegalDateEditor,
  launch_time_series: LaunchTimeEditor,
  bid_limit: OceanBidLimitEditor,
  qudaohao: QudaohaoEditor,
};

/** 取巨量 targeting_type 对应的编辑器；未知类型返回 GenericConfigEditor。 */
export function getOceanRedlineEditor(
  targeting_type: string,
): ComponentType<EditorProps> {
  return OCEAN_REDLINE_EDITOR_MAP[targeting_type] ?? GenericConfigEditor;
}
